import { isBoolean, isNumber, isString } from "lodash";
import { Primitive } from "../types";

export const isPrimitive = (value: unknown): value is Primitive =>
  isNumber(value) || isString(value) || isBoolean(value);
